export default __webpack_public_path__ + "static/media/Account.d4e30add.svg";